import { AcsElement, ProCourse, ProModule } from '../../quizzes/models/quiz-builder-pro.model';
import { Scenario, ScenarioQuestion } from './scenario.model';

/** Fictional example for learning the builder, opened as an independent editable flow. */
export const PRACTICE_SCENARIO: Scenario = {
  title: 'Practice: Pine Lake fuel stop',
  subtitle: 'Crash course · fictional example',
  steps: [
    { id: 'brief', type: 'narrative', title: 'Briefing', x: 40, y: 200, next: 'decide',
      body: 'This is a fictional exercise for learning Scenario Builder. The places, numbers, and club rule are made up.\n\n' +
        'Sam is flying a club airplane to Pine Lake Airfield. For this exercise, the club requires arrival with 45 minutes of fuel left. ' +
        'Sam has 50 minutes of fuel. Pine Lake is 20 minutes away. Cedar Strip, a fuel stop, is 5 minutes away.' },
    { id: 'decide', type: 'question', title: 'Decision point', x: 320, y: 200, onCorrect: 'debrief', onIncorrect: 'rethink',
      question: {
        kind: 'multiple-choice', points: 5, title: 'Which plan meets the fictional club rule?',
        choices: [
          { text: 'Stop at Cedar Strip to refuel', correct: true },
          { text: 'Continue to Pine Lake without refueling', why: '50 minus 20 leaves 30 minutes, below the fictional 45-minute rule.' },
        ],
        explanation: 'In this exercise, 50 minutes minus 20 leaves 30. Stopping at Cedar Strip leaves 45 minutes on arrival and allows refueling.',
      } },
    { id: 'rethink', type: 'remediation', title: 'Check the math', x: 620, y: 360, next: 'decide',
      body: 'Subtract the trip time from the fuel remaining, then compare it with the fictional club rule. ' +
        'Pine Lake: 50 − 20 = 30 minutes. Cedar Strip: 50 − 5 = 45 minutes. Return to the question and try again.' },
    { id: 'debrief', type: 'debrief', title: 'Debrief', x: 620, y: 60,
      body: 'Sam chose the fuel stop that met the fictional club rule.\n\n' +
        'You have seen a complete scenario: a briefing, a decision, help and a retry after an incorrect answer, and a debrief.' },
  ],
};

/** Prepared AI targets and drafts for the walkthrough, so its AI beats never call the API. */
export const PRACTICE_AI = {
  courses: {
    courses: [{ id: 1, name: 'Private Pilot (demo)', acsTestId: 1 }] as ProCourse[],
    modules: [{ id: 11, courseId: 1, label: '4 — Cross-country planning' }] as ProModule[],
  },
  acs: [
    { code: 'PA.I.D.K1', description: 'Route planning', missRate: 18, area: 'I. Preflight Preparation', task: 'D. Cross-Country Flight Planning' },
    { code: 'PA.I.D.K3c', description: 'Fuel requirements, including reserve', missRate: 31, area: 'I. Preflight Preparation',
      task: 'D. Cross-Country Flight Planning' },
    { code: 'PA.I.D.R6', description: 'Fuel planning', missRate: 24, area: 'I. Preflight Preparation',
      task: 'D. Cross-Country Flight Planning' },
  ] as AcsElement[],
  topic: 'Fuel reserve on a short diversion',
  /** First draft, then the version "Try another version" returns: the practice question the rest of the walkthrough uses. */
  drafts: [
    { kind: 'multiple-choice', points: 5, title: 'How much fuel will Sam have on arrival at Pine Lake?',
      choices: [{ text: '30 minutes', correct: true }, { text: '45 minutes' }, { text: '70 minutes' }],
      explanation: 'In this exercise, 50 minutes of fuel minus a 20-minute flight leaves 30 minutes.' },
    PRACTICE_SCENARIO.steps[1].question,
  ] as ScenarioQuestion[],
};
